export default [
  {
    path: '/transfers_erc1155',
    name: 'ERC1155TransferView',
    component: () =>
      import(
        /* webpackChunkName: "erc1155" */ '@/views/ERC1155/ERC1155TransferView.vue'
      ),
    meta: { title: 'ERC1155 Transfers', group: 'erc1155' },
  },
  {
    path: '/holders_erc1155',
    name: 'ERC1155HolderView',
    component: () =>
      import(
        /* webpackChunkName: "erc1155" */ '@/views/ERC1155/ERC1155HolderView.vue'
      ),
    meta: { title: 'ERC1155 Holders', group: 'erc1155' },
  },
  {
    path: '/inventory_erc1155',
    name: 'ERC1155InventoryView',
    component: () =>
      import(
        /* webpackChunkName: "erc1155" */ '@/views/ERC1155/ERC1155InventoryView.vue'
      ),
    meta: { title: 'ERC1155 Inventory', group: 'erc1155' },
  },
  {
    path: '/transaction_erc1155',
    name: 'ERC1155TransactionView',
    component: () =>
      import(
        /* webpackChunkName: "erc1155" */ '@/views/ERC1155/ERC1155TransactionView.vue'
      ),
    meta: { title: 'ERC1155 Transaction', group: 'erc1155' },
  },
  {
    path: '/minting_request_nft1155',
    name: 'NFT1155AddView',
    component: () =>
      import(
        /* webpackChunkName: "erc1155" */ '@/views/ERC1155/NFT1155AddView.vue'
      ),
    meta: { title: 'NFT1155 Minting Request', group: 'erc1155' },
  },
  {
    path: '/minting_process_nft1155',
    name: 'NFT1155MintView',
    component: () =>
      import(
        /* webpackChunkName: "erc1155" */ '@/views/ERC1155/NFT1155MintView.vue'
      ),
    meta: { title: 'NFT1155 Minting Process', group: 'erc1155' },
  },
]
